<template>
    <div id="lang-switcher" v-if="startRender">
        <img class="flag-icon not-close-onclick" :src="resolve_img_url(getSelectedLangFlag())" @click="showLangList()" />
        <div id="lang-list">
            <div v-for="(lang,i) in locales" :key="i">
                <div v-if="i > 0" class="separe" />
                <img class="flag-icon" :src="resolve_img_url(lang_img[lang])" @click="switchLanguage(lang)"> 
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import axios from 'axios'

    export default {
        name: 'LangSwitcher',
        data() {
            return {
               locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(','),
               default_lang: process.env.VUE_APP_I18N_LOCALE,
               startRender: false,
               lang_img: {}
            }
        },
        beforeMount() {
            this.setEnvLang();

            axios.get(process.env.VUE_APP_ENDPOINT_URL +"/config/lang.json").then(response => {  
                this.lang_img = response.data;
                this.startRender = true; 
            }).catch(err => { 
                console.error(err);
            });

            $(document).click(function(event) {
                if(event.target.classList.toString().includes("lang-list")) { 
                    event.preventDefault();

                }else if(event.target.classList.toString().includes("not-close-onclick")) { 
                    return;
                }else{
                    $("#lang-list").fadeOut();
                }
            });
        },
        methods: { 
            resolve_img_url: function (path) { 
                let images = require.context('./../assets/', false, /\.png$|\.jpg$|\.gif$/)
                return images("./"+path)
            },
            setEnvLang() { 
                if(window.navigator.language.includes('it')){
                    this.default_lang = "it";
                    this.$i18n.locale = "it";

                    localStorage.setItem("receipt_lang", "it");
                    
                }else if(window.navigator.language.includes('en')){
                    this.default_lang = "en";
                    this.$i18n.locale = "en";

                    localStorage.setItem("receipt_lang", "en");

                }else{
                    let lan = localStorage.getItem("receipt_lang");
                    if(lan != '' && lan != null){ 
                        this.default_lang = lan;
                        this.$i18n.locale = lan;

                    }else{
                        this.default_lang = "en";
                        this.$i18n.locale = "en";

                        localStorage.setItem("receipt_lang", "en");
                    }
                }                
            },
            showLangList() {
                $("#lang-list").fadeIn();
            },
            getSelectedLangFlag() {
                return this.lang_img[this.$i18n.locale];
            },
            switchLanguage(lang) {
                if (this.$i18n.locale !== lang) {
                    this.$i18n.locale = lang;
                    localStorage.setItem("receipt_lang", lang);
                }
            }
        },
    }
</script>

<style>
    #lang-list {
        z-index: 10;
        padding: 5px;
        display: none;
        margin-top: 15px;
        position: absolute;
        border: 1px solid #ccc;
        background-color: white;
    }
    .separe {
        width: 100%;
        height: 5px;
        margin-bottom: 5px;
        border-bottom: 1px solid #ccc;
    }
    div#lang-switcher img {
        height: 13px;
    }
</style>